import * as vp from 'vopay';
import { api } from '@/services/api.config';

export default function useFetchAccountBranding() {
  async function fetchAccountBranding(requestParams?: vp.AccountBrandingRequest) {
    try {
      const res = await api.fetchAccountBranding({ Product: vp.BrandingProductType.Portal, ...requestParams });

      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return {
    fetchAccountBranding,
  };
}
